import { DynamicStandaloneTag, DynamicStandaloneTagProps } from '@/components/Tag';

import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type VideoTeaserContentTagProps = DynamicStandaloneTagProps;

export const VideoTeaserContentTagComponent: StandaloneComponent<VideoTeaserContentTagProps> = (props) => {
  return (
    <DynamicStandaloneTag
      {...mergeProps(
        {
          options: {
            variant: 'text',
          },
        },
        props,
        {
          link: {
            options: {
              className: 'flex',
            },
          },
        }
      )}
    />
  );
};
